/* TAMAWANT ATELIER v1.0 — COD leads only. Never calls /cart/add.js, /checkouts, or Shopify Orders API. */
(() => {
  'use strict';
  const cfg = window.TamawantConfig || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const money = (value) => {
    const n = Number(value) || 0;
    try { return new Intl.NumberFormat('fr-MA', { style: 'currency', currency: cfg.currency || 'MAD', maximumFractionDigits: 2 }).format(n); }
    catch (_) { return n.toFixed(2) + ' MAD'; }
  };
  const safeNumber = (v) => Number.isFinite(Number(v)) ? Number(v) : 0;

  const menu = $('[data-mobile-panel]');
  const overlay = $('[data-menu-overlay]');
  const openMenu = (open) => {
    if (!menu || !overlay) return;
    menu.classList.toggle('open', open);
    overlay.classList.toggle('open', open);
    document.body.classList.toggle('no-scroll', open);
    $('[data-menu-open]')?.setAttribute('aria-expanded', String(open));
  };
  $('[data-menu-open]')?.addEventListener('click', () => openMenu(true));
  $('[data-menu-close]')?.addEventListener('click', () => openMenu(false));
  overlay?.addEventListener('click', () => openMenu(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { openMenu(false); $('#header-search')?.classList.remove('open'); } });
  $('[data-search-toggle]')?.addEventListener('click', () => {
    const node = $('#header-search'); if (!node) return;
    const isOpen = node.classList.toggle('open');
    $('[data-search-toggle]')?.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) $('#header-search-input')?.focus();
  });
  $$('[data-gallery-image]').forEach(btn => btn.addEventListener('click', () => {
    const main = $('[data-main-image]');
    if (main) { main.src = btn.dataset.galleryImage; main.classList.add('real-image'); }
    $$('[data-gallery-image]').forEach(el => el.classList.remove('active'));
    btn.classList.add('active');
  }));

  const tracking = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
  const landingParams = new URLSearchParams(location.search);
  const attribution = {};
  tracking.forEach(k => {
    const val = landingParams.get(k);
    if (val) {
      attribution[k] = String(val).slice(0, 250);
      try { sessionStorage.setItem('tmw_' + k, attribution[k]); } catch (_) { /* storage may be blocked */ }
    } else {
      try { attribution[k] = sessionStorage.getItem('tmw_' + k) || ''; } catch (_) { attribution[k] = ''; }
    }
  });
  const revealTarget = $$('.section-head,.collection-tile,.story-content,.journal-card');
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); } });
    }, { threshold: 0.08 });
    revealTarget.forEach(el => { el.classList.add('reveal'); observer.observe(el); });
  }

  const recommendations = $('[data-product-recommendations-url]');
  if (recommendations) {
    fetch(recommendations.dataset.productRecommendationsUrl)
      .then(res => res.ok ? res.text() : '')
      .then(html => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sec = doc.querySelector('.product-reco');
        if (sec) recommendations.replaceWith(sec);
      }).catch(() => {});
  }
  const controller = $('[data-product-controller]');
  if (!controller) return;
  let variants = [];
  try { variants = JSON.parse(controller.dataset.variants || '[]'); } catch (_) { /* missing */ }
  const variantSelect = $('[data-variant-select]', controller);
  const quantityInput = $('[data-quantity]', controller);
  const codForm = $('[data-cod-form]', controller);
  const currentVariant = () => variants.find(v => String(v.id) === String(variantSelect?.value)) || variants[0] || null;
  const quantity = () => Math.max(1, Math.min(99, Math.trunc(safeNumber(quantityInput?.value) || 1)));
  const shipping = (subtotal) => {
    const free = safeNumber(cfg.freeShippingFrom);
    if (free > 0 && subtotal >= free) return 0;
    return Math.max(0, safeNumber(cfg.baseShipping));
  };
  const compute = () => {
    const variant = currentVariant();
    if (!variant) return null;
    const count = quantity();
    const unit = safeNumber(variant.price) / 100;
    const subtotal = Math.round(unit * count * 100) / 100;
    const fee = shipping(subtotal);
    const total = subtotal + fee;
    const mobileTotal = $('[data-mobile-total]'); if (mobileTotal) mobileTotal.textContent = money(total);
    $('[data-product-price]', controller) && ($('[data-product-price]', controller).textContent = money(unit));
    $('[data-cod-subtotal]', controller) && ($('[data-cod-subtotal]', controller).textContent = money(subtotal));
    $('[data-cod-line-subtotal]', controller) && ($('[data-cod-line-subtotal]', controller).textContent = money(subtotal));
    $('[data-cod-shipping]', controller) && ($('[data-cod-shipping]', controller).textContent = fee === 0 ? 'Offerte' : money(fee));
    $('[data-cod-grandtotal]', controller) && ($('[data-cod-grandtotal]', controller).textContent = money(total));
    $('[data-cod-variant]', controller) && ($('[data-cod-variant]', controller).textContent = variant.title);
    if (quantityInput) quantityInput.value = String(count);
    return { variant, quantity: count, subtotal, shipping: fee, total, unit };
  };
  quantityInput?.addEventListener('input', compute);
  variantSelect?.addEventListener('change', () => {
    const v = currentVariant();
    if (v && v.featured_image && v.featured_image.src) {
      const image = $('[data-main-image]');
      if (image) { image.src = v.featured_image.src; image.classList.add('real-image'); }
    }
    compute();
  });
  $('[data-quantity-plus]', controller)?.addEventListener('click', () => { quantityInput.value = String(Math.min(99, quantity() + 1)); compute(); });
  $('[data-quantity-minus]', controller)?.addEventListener('click', () => { quantityInput.value = String(Math.max(1, quantity() - 1)); compute(); });
  $$('[data-scroll-to-cod]', controller).forEach(btn => btn.addEventListener('click', () => { const f = $('[name=full_name]', controller); if (f) setTimeout(() => f.focus({ preventScroll: true }), 300); }));
  compute();
  const floating = $('[data-mobile-order]');
  const codAnchor = $('#commande');
  if (floating && codAnchor && 'IntersectionObserver' in window) {
    let formVisible = false;
    const toggleFloating = () => floating.classList.toggle('visible', window.scrollY > 250 && !formVisible);
    new IntersectionObserver(entries => {
      formVisible = entries[0]?.isIntersecting || false;
      toggleFloating();
    }, { threshold: 0.05 }).observe(codAnchor);
    window.addEventListener('scroll', toggleFloating, { passive: true });
    floating.querySelector('a')?.addEventListener('click', () => floating.classList.remove('visible'));
  }
  if (!codForm) return;
  const submitButton = $('[data-cod-submit]', codForm);
  const feedback = $('[data-cod-feedback]', codForm);
  const phoneValid = value => /^(?:0[567]\d{8}|(?:\+212|00212)[567]\d{8})$/.test(value.replace(/[\s().-]/g, ''));
  let inFlight = false;
  let pendingLeadId = null;
  const showMessage = (message, success = false) => {
    if (!feedback) return;
    feedback.hidden = false;
    feedback.classList.toggle('success', !!success);
    feedback.textContent = message;
  };
  codForm.addEventListener('submit', async event => {
    event.preventDefault();
    if (inFlight) return;
    if (!codForm.reportValidity()) return;
    const formData = new FormData(codForm);
    if (String(formData.get('company_website') || '').trim()) return;
    if (!phoneValid(String(formData.get('phone') || ''))) {
      showMessage('Veuillez saisir un numéro marocain valide (ex. 06 12 34 56 78).');
      $('[name=phone]',codForm)?.focus();
      return;
    }
    const calc = compute();
    if (!calc || !calc.variant?.available) {
      showMessage('Ce format n’est plus disponible. Veuillez choisir une autre option.');
      return;
    }
    if (!cfg.leadEndpoint || !/^https:\/\//.test(cfg.leadEndpoint)) {
      showMessage('La réception des demandes n’est pas encore configurée. Veuillez nous contacter.');
      return;
    }
    if (!pendingLeadId) pendingLeadId = (crypto.randomUUID?.() || 'lead-' + Date.now() + '-' + Math.random().toString(36).slice(2));
    const token = $('[name="cf-turnstile-response"]',codForm)?.value || '';
    const lead = {
      lead_id: pendingLeadId,
      full_name: String(formData.get('full_name') || '').trim(),
      phone: String(formData.get('phone') || '').trim(),
      city: String(formData.get('city') || '').trim(),
      address: String(formData.get('address') || '').trim(),
      notes: String(formData.get('notes') || '').trim(),
      consent: !!formData.get('consent'),
      product_id: String(controller.dataset.productId || ''),
      product_title: String(controller.dataset.productTitle || ''),
      variant_id: String(calc.variant.id),
      variant_title: String(calc.variant.public_title || calc.variant.title || ''),
      quantity: calc.quantity,
      unit_price_mad: calc.unit,
      subtotal_mad: calc.subtotal,
      shipping_mad: calc.shipping,
      total_mad: calc.total,
      currency: String(cfg.currency || 'MAD'),
      product_url: String(controller.dataset.productUrl || location.href),
      landing_url: location.href,
      referrer: document.referrer?.slice(0, 500) || '',
      turnstile_token: token,
      ...attribution
    };
    inFlight = true;
    submitButton.disabled = true;
    submitButton.textContent = 'Transmission en cours…';
    feedback.hidden = true;
    const abort = new AbortController();
    const timeout = setTimeout(() => abort.abort(), 16000);
    try {
      const response = await fetch(cfg.leadEndpoint, {
        method: 'POST', mode: 'cors', cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(lead),
        signal: abort.signal
      });
      let result = null;
      try { result = await response.json(); } catch (_) { /* invalid reply is not success */ }
      if (!response.ok || !result || result.ok !== true || result.saved !== true || result.lead_id !== pendingLeadId) {
        throw new Error('Les données n’ont pas été confirmées par le serveur.');
      }
      // Confirmation only happens after a successful, verified sheet write acknowledgement.
      const panel = $('[data-cod-panel]', controller);
      const safeId = String(result.lead_id).slice(0, 80).replace(/[^a-zA-Z0-9_-]/g, '');
      panel.innerHTML = `<div class="cod-success-panel"><div class="success-icon"><svg class="icon icon-lg" viewBox="0 0 24 24"><path d="m4 12 5 5L20 6"/></svg></div><h2>Merci pour votre confiance !</h2><p>Votre demande a bien été enregistrée. Notre équipe vous contactera par téléphone pour confirmer les détails et la livraison. <strong>Ce n'est pas encore une commande confirmée.</strong></p><p>Référence de suivi : <strong>${safeId}</strong></p><a class="btn btn-outline" href="/collections/all">Continuer la découverte →</a></div>`;
      pendingLeadId = null;
      // Send only anonymous conversion metadata to existing analytics providers, never customer PII.
      const conversion = { event:'tamawant_lead_saved', product_id:controller.dataset.productId, currency:cfg.currency || 'MAD', value:calc.total };
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(conversion);
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_ids:[controller.dataset.productId], currency:cfg.currency || 'MAD', value:calc.total });
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (error) {
      const msg = error?.name === 'AbortError' ? 'Le serveur met trop de temps à répondre. Veuillez réessayer. Votre référence est conservée pour éviter les doublons.' : 'Impossible de confirmer l’enregistrement de la demande. Réessayez ou contactez notre équipe.';
      showMessage(msg);
      submitButton.disabled = false;
      submitButton.textContent = 'Réessayer l’envoi →';
      // Retry reuses lead_id, server deduplicates.
      if (window.turnstile && token) { try { window.turnstile.reset(); } catch (_) {} }
    } finally { clearTimeout(timeout); inFlight = false; }
  });
})();
